

/**
* @component Link
*
* @note could be used to preload pages/assets.
*
* @public
*/

export default {
  name: 'Link',
};
